module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thumbnail",
    class: _vm.condition.class,
    attrs: {
      "title": _vm.condition.title
    }
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.isAttacking) ? _c('div', {
    staticClass: "attacking bg-danger",
    attrs: {
      "title": _vm.player.name + ' is attacking'
    }
  }, [_vm._v("\n\t\t\tOn attack! \n\t\t\t"), _c('i', {
    staticClass: "fa fa-bolt",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.player.name))]), _vm._v(" "), _c('div', {
    staticClass: "progress",
    attrs: {
      "title": "Life"
    }
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    style: ('width: ' + _vm.lifeStatus + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.lifeStatus,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v("\n\t\t    " + _vm._s(_vm.lifeStatus) + "%\n\t\t  ")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "label label-primary"
  }, [_vm._v("Health: " + _vm._s(_vm.player.health))]), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Agility: " + _vm._s(_vm.player.agility))]), _vm._v(" "), _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("Defense: " + _vm._s(_vm.player.defense))])])]), _vm._v(" "), _c('div', {
    staticClass: "container-image"
  }, [(_vm.player.avatar) ? _c('img', {
    attrs: {
      "src": _vm.apiUrl + _vm.player.avatar,
      "alt": _vm.player.name
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [(_vm.player.attacks) ? _c('ul', {
    staticClass: "list-group",
    attrs: {
      "title": "Attacks"
    }
  }, _vm._l((_vm.player.attacks), function(attack) {
    return _c('li', {
      staticClass: "list-group-item",
      class: {
        'attack-click': !_vm.isCpu && !_vm.isAttacking
      },
      attrs: {
        "title": !_vm.isCpu && !_vm.isAttacking ? 'Click to trigger attack' : ''
      },
      on: {
        "click": function($event) {
          _vm.hit(attack)
        }
      }
    }, [_c('span', {
      staticClass: "attack-name"
    }, [_vm._v(_vm._s(attack.name))]), _vm._v(" "), _c('span', {
      staticClass: "label label-default",
      attrs: {
        "title": "Type"
      }
    }, [_vm._v(_vm._s(attack.type))]), _vm._v(" "), _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Power: " + _vm._s(attack.power))]), _vm._v(" "), _c('span', {
      staticClass: "label label-warning",
      attrs: {
        "title": "Accuracy"
      }
    }, [_vm._v("Acc.: " + _vm._s(attack.accuracy))])])
  })) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0213a4f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/battle/character/index.vue
// module id = 119
// module chunks = 1